import { useState } from 'react';

import { useLocation } from 'react-router-dom';

import { useTableContext } from '@shared/components/Table';

export const PaginationRows = () => {
  const pathname = useLocation().pathname;
  const isWalletsPage = pathname.startsWith('/wallets');
  const [possiblePages] = useState(
    isWalletsPage ? ['10', '50', '100', '200'] : ['50', '100', '200'],
  );
  const { size, setSize } = useTableContext();
  return (
    <>
      <div className='pagination-changer'>
        <div className='pagination-changer__item'>Rows:</div>
        {possiblePages.map(page => (
          <div
            key={page}
            className={`page-item${size === page ? ' is-active' : ''}`}
            onClick={() => setSize(page)}
            onKeyDown={() => setSize(page)}
            role='button'
            tabIndex={0}
          >
            {page}
          </div>
        ))}
      </div>
    </>
  );
};
